import React from 'react';

import { Stack } from '@metarouter-private/mr-mui';
import {
  useAuditLogPage,
  useAuditLogActionOptions,
  PAGE_SIZE,
  QUERY_STATUS,
  keysetPaging,
} from '@ion/api/audit-logs/query';

import AuditLogFilterBar from './AuditLogFilterBar';
import useAuditLogFilters from './AuditLogFilterBar/useAuditLogFilters';
import AuditLogTable from './AuditLogTable';
import AuditLogEmptyState from './AuditLogEmptyState';
import AuditLogErrorState from './AuditLogErrorState';
import AuditLogEndOfHistory from './AuditLogEndOfHistory';
import AuditLogStatus from './AuditLogStatus';
import AuditLogPager from './AuditLogPager';
import auditLogPropTypes from 'app/audit-logs/auditLogPropTypes';

export default function AuditLogPanelForRecord({ recordRef }) {
  const { filters, setChildType, setChildId, setAction, setUserSearchTerm, setDateRange } = useAuditLogFilters();
  const { rows, pageInfo, hasActiveFilters, loading, status, sortDirection, onSortDirectionChange } = useAuditLogPage({
    recordRef,
    filters,
    pagingStrategy: keysetPaging,
    pageSize: PAGE_SIZE,
  });
  const { actions: distinctActions } = useAuditLogActionOptions({ recordRef, filters });

  return (
    <Stack spacing={2}>
      <AuditLogFilterBar
        recordRef={recordRef}
        filters={filters}
        distinctActions={distinctActions}
        onChildTypeChange={setChildType}
        onChildIdChange={setChildId}
        onActionChange={setAction}
        onUserSearchTermChange={setUserSearchTerm}
        onDateRangeChange={setDateRange}
      />
      <AuditLogStatus count={rows.length} status={status} />
      {renderRecordBody({ status, rows, loading, pageInfo, hasActiveFilters, sortDirection, onSortDirectionChange })}
    </Stack>
  );
}

function renderRecordBody({ status, rows, loading, pageInfo, hasActiveFilters, sortDirection, onSortDirectionChange }) {
  if (status === QUERY_STATUS.ERROR) return <AuditLogErrorState />;
  if (status === QUERY_STATUS.EMPTY) return <AuditLogEmptyState filtered={hasActiveFilters} />;

  return (
    <>
      <AuditLogTable
        rows={rows}
        loading={loading}
        hasActiveFilters={hasActiveFilters}
        sortDirection={sortDirection}
        onSort={onSortDirectionChange}
      />
      <AuditLogPager
        onPrev={pageInfo.goToPreviousPage}
        onNext={pageInfo.goToNextPage}
        hasPrevPage={pageInfo.hasPrevPage}
        hasNextPage={pageInfo.hasNextPage}
      />
      {status === QUERY_STATUS.READY && !pageInfo.hasNextPage && <AuditLogEndOfHistory />}
    </>
  );
}

AuditLogPanelForRecord.propTypes = {
  recordRef: auditLogPropTypes.recordRef.isRequired,
};
